module.exports = __webpack_public_path__ + "img/electrovalence-ping@2x.8dbda3fe.png";